import { GUARDAR_PLAN, GUARDAR_PLAN_ERROR, GUARDAR_PLAN_SUCCESS, GUARDAR_PLAN_ZONA, GUARDAR_PLAN_ZONA_ERROR, GUARDAR_PLAN_ZONA_SUCCESS, LISTAR_ZONA_ACTIVA, LISTAR_ZONA_ACTIVA_SUCCESS, PLAN_LISTAR, PLAN_LISTAR_ERROR, PLAN_LISTAR_SUCCESS, PLAN_ZONA_LISTAR, PLAN_ZONA_LISTAR_ERROR, PLAN_ZONA_LISTAR_SUCCESS } from './PlanesActions';

const initialState = {
  isActivityIndicatorShown: false,
  planes: [],
  paginacion: {
    limite: 10,
    actual: 1,
    filtro: '',
    orden: 'id',
    sentido: 'ASC',
    total: 0,
  },
  isActivityIndicatorShown: false,
  error: null,
};

const planesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLAN_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
      case PLAN_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        plan: action.respuestaServidor.plan,
        paginacion: action.respuestaServidor.paginacion,
      };


      case PLAN_ZONA_LISTAR:
        return {
          ...state,
          isActivityIndicatorShown: true,
        };
  
      
      case PLAN_ZONA_LISTAR_SUCCESS:
        
  
        return {
          ...state,
          isActivityIndicatorShown: false,
          planZona: action.respuestaServidor.planZona,
          paginacion: action.respuestaServidor.paginacion,
        };

        case LISTAR_ZONA_ACTIVA:
          return {
            ...state,
            isActivityIndicatorShown: true,
          };
    
        
        case LISTAR_ZONA_ACTIVA_SUCCESS:
          return {
            ...state,
            isActivityIndicatorShown: false,
            zonas: action.respuestaServidor.zonas,
          };

    case GUARDAR_PLAN:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
      

    case GUARDAR_PLAN_ZONA:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };

    case GUARDAR_PLAN_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,

      };

    case GUARDAR_PLAN_ZONA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    // case ACTUALIZAR_PLACA_SUCCESS:
    //   return {
    //     ...state,
    //     isActivityIndicatorShown: false,
    //     placas: state.placas.map((placa) =>
    //       placa.id === action.respuestaServidor.id
    //         ? action.respuestaServidor
    //         : placa
    //     ), // Actualiza la placa en la lista
    //     error: null,
    //   };
    case PLAN_LISTAR_ERROR:
    case PLAN_ZONA_LISTAR_ERROR:
    case GUARDAR_PLAN_ERROR:
    case GUARDAR_PLAN_ZONA_ERROR:
    //case ACTUALIZAR_PLACA_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    default:
      return state;
  }
};

export default planesReducer;
